export default __webpack_public_path__ + "static/media/Green-Android-5.b9a9516a.png";